// extracted by mini-css-extract-plugin
export default {"primary-color":"#426361","secondary-color":"#6d9e9b","bg-color":"#e8f4f4"};